import { handleLocalStorage } from '@/assets/js/utils.js';
export default {
  props: {
    audiSettingInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      checkedAec: '',
      checkedAns: '',
      checkedAgc: '',
      audioMode: 'mono',
      audioProfile: 'high_quality',
      audioSettingList: [{
        type: 'AEC',
        checked: false,
        i18n: 'common.aecTips',
        localKey: 'checkedAec'
      }, {
        type: 'ANS',
        checked: false,
        i18n: 'common.ansTips',
        localKey: 'checkedAns'
      }, {
        type: 'AGC',
        checked: false,
        i18n: 'common.agcTips',
        localKey: 'checkedAgc'
      }]
    };
  },
  computed: {
    profiles() {
      if (this.audioMode === 'mono') {
        return [{
          text: 'speechLowQuality',
          value: 'speech_low_quality'
        }, {
          text: 'speechStandard',
          value: 'speech_standard'
        }, {
          text: 'musicStandrad',
          value: 'music_standard'
        }, {
          text: 'highQuality',
          value: 'high_quality'
        }];
      } else {
        return [{
          text: 'standardStereo',
          value: 'standard_stereo'
        }, {
          text: 'highQualityStereo',
          value: 'high_quality_stereo'
        }];
      }
    }
  },
  created() {
    this.checkedAec = handleLocalStorage('get', 'checkedAec') ? JSON.parse(handleLocalStorage('get', 'checkedAec')) : true;
    this.checkedAns = handleLocalStorage('get', 'checkedAns') ? JSON.parse(handleLocalStorage('get', 'checkedAns')) : true;
    this.checkedAgc = handleLocalStorage('get', 'checkedAgc') ? JSON.parse(handleLocalStorage('get', 'checkedAgc')) : true;
    this.audioProfile = handleLocalStorage('get', 'audioQualityPreset') || 'high_quality';
    if (!this.checkedAec && !this.checkedAns && !this.checkedAgc && (this.audioProfile == 'standard_stereo' || this.audioProfile == 'high_quality_stereo')) {
      this.audioMode = 'stereo';
    } else {
      this.audioMode = 'mono';
    }
    this.setAduioNoisySetting();
  },
  methods: {
    setAduioNoisySetting() {
      this.audioSettingList.forEach(item => {
        switch (item.type) {
          case 'AEC':
            item.checked = this.checkedAec;
            break;
          case 'ANS':
            item.checked = this.checkedAns;
            break;
          case 'AGC':
            item.checked = this.checkedAgc;
            break;
        }
      });
    },
    setAduioSetting() {
      handleLocalStorage('set', 'checkedAec', this.checkedAec);
      handleLocalStorage('set', 'checkedAns', this.checkedAns);
      handleLocalStorage('set', 'checkedAgc', this.checkedAgc);
      handleLocalStorage('set', 'audioQualityPreset', this.audioProfile);
      this.audiSettingInfo.show = false;
      if (this.$route.name != 'preview') {
        window.location.reload();
      }
    },
    cancelAudioSetting() {
      this.audiSettingInfo.show = false;
    },
    saveOperation(key, val, checkbox) {
      this[key] = val;
      // 操作勾选框时才需要记录数据
      if (checkbox) {
        this.setAduioNoisySetting();
      }
    },
    // 切换音频模式
    onAudioModeChange(newMode) {
      // 切换音频模式时，重置aec、agc、ans
      // 单声道的音频质量，默认为 high_quality
      // 立体声的音频质量，默认为 standard_stereo
      this.audioProfile = newMode === 'mono' ? 'high_quality' : 'standard_stereo';
      if (newMode == 'mono') {
        this.audioSettingList.forEach(item => {
          switch (item.type) {
            case 'AEC':
              this.checkedAec = item.checked;
              break;
            case 'ANS':
              this.checkedAns = item.checked;
              break;
            case 'AGC':
              this.checkedAgc = item.checked;
              break;
          }
        });
      } else {
        this.checkedAec = false;
        this.checkedAns = false;
        this.checkedAgc = false;
      }
    },
    cancelAdvanced() {
      this.audiSettingInfo.show = false;
    },
    // 保存关闭
    closeAdvanced() {
      handleLocalStorage('set', 'checkedAec', this.checkedAec);
      handleLocalStorage('set', 'checkedAns', this.checkedAns);
      handleLocalStorage('set', 'checkedAgc', this.checkedAgc);
      handleLocalStorage('set', 'audioQualityPreset', this.audioProfile);
      this.audiSettingInfo.show = false;
      if (this.$route.name == 'coordinationParticipate') {
        window.location.reload();
      }
    }
  }
};